export default __webpack_public_path__ + "static/media/chuchuang.2f663ce6.png";